import { render, staticRenderFns } from "./StarDisplay.vue?vue&type=template&id=174deefe&scoped=true&"
import script from "./StarDisplay.vue?vue&type=script&lang=js&"
export * from "./StarDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174deefe",
  null
  
)

export default component.exports